import { createFileRoute, redirect } from '@tanstack/react-router';

/** Legacy singular URL → plural. */
export const Route = createFileRoute('/product/$id')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/products/$id',
      params: { id: params.id },
      search,
      replace: true,
    });
  },
});
